<template>
<b-container fluid>
    <b-row>
        <b-col cols="12"><ActionBarPayment/></b-col>        
    </b-row>
    <b-row>
        <b-col cols="8">
          <PaymentSummary/>          
          <Lines/>
        </b-col>
        <b-col>          
          <PaymentInput/>
        </b-col>        
    </b-row>
</b-container>
</template>

<script>
import PaymentInput from '@/components/PaymentInput.vue'
import PaymentSummary from '@/components/PaymentSummary.vue'
import ActionBarPayment from '@/components/ActionBarPayment.vue'
import Lines from '@/components/Lines.vue'
import mixin from '@/components/mixin.js'

export default {
  mixins:[mixin],
  name: 'Payment',
  components: {
    PaymentInput,
    PaymentSummary,
    ActionBarPayment,
    Lines
  },
  created: function () {
        this.$store.commit('clearPaymMethod')
        this.$store.commit('setPaymMethod',this.$store.state.orderPrePayments)
  },
}
</script>
